<template>
  <div
    v-if="!passive || inputValue"
    :class="['checkbox', { error: hasValidationError }]"
    :style="!passive ? 'max-height: 16px;' : null"
    ref="parent"
  >
    <div
      :class="[
        'checkbox__indicator',
        { checkbox__indicator__active: inputValue, [size]: true },
      ]"
      @click="(e) => !passive && click(e)"
    >
      <svg v-if="inputValue" class="indicator__icon" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.37738 5.41375L8.13567 1.10098C8.40726 0.854821 8.82159 0.855853 9.09195 1.10337C9.40037 1.38572 9.39923 1.87213 9.08948 2.15303L3.60902 7.12322C3.47736 7.24263 3.27678 7.24333 3.14429 7.12485L0.910358 5.12717C0.599682 4.84935 0.592624 4.36539 0.895066 4.07863C1.1637 3.82393 1.5826 3.81727 1.8592 4.0633L3.37738 5.41375Z" fill="white"/>
      </svg>
    </div>
    <input
      type="hidden"
      ref="checkbox"
      v-model="inputValue"
      class="checkbox__value"
      :name="name"
      :disabled="disabled"
    />
    <label
      :class="['checkbox__label', { small: smallText }, { passive }]"
      v-if="label"
      v-html="label"
      @click.self="(e) => !passive && click(e)"
    />
    <slot v-if="hasValidationError" class="validation-messages" />
  </div>
</template>

<script>
import Vue from 'vue'
import Base from './Vinput/Base/Base.vue'

export default Vue.extend({
  name: 'checkbox',
  inject: { formData: { from: 'formData', default: null } },
  extends: Base,
  validations () {
    return {
      inputValue: this.rules
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    passive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    smallText: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      defaultValue: false
    }
  },
  computed: {
    rules () {
      const validators = {}

      if (this.required) {
        validators.required = (val) => val === true
      }

      return validators
    },
    inputValue: {
      get () {
        if (this.name && this.formData[this.name] !== undefined) {
          return this.formData[this.name]
        } else {
          return this.value
        }
      },
      set (val) {
        if (this.name && this.formData[this.name] !== undefined) {
          Vue.set(this.formData, this.name, val)
        } else {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    click () {
      if (!this.disabled) {
        this.inputValue = !this.inputValue
      }
    }
  }
})
</script>

<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  flex-direction: row !important;
  position: relative;

  &.error {
    .checkbox__indicator {
      border: 1px solid $color_error;
    }
    .checkbox__label {
      color: $color_error;
    }
  }

  .checkbox__indicator {
    transition: border 0.2s;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #7b8996;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .indicator__icon {
      position: absolute;
      width: 10px;
      height: 10px;
      fill: white;
    }
  }

  .small {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }

  .large {
   width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;

    .indicator__icon {
      width: 15px;
      height: 15px;
    }
  }

  .checkbox__indicator__active {
    border-color: #0094ff;
    background: #0094ff;
  }

  .checkbox__label {
    margin-left: 8px;
    transition: color 0.2s;
    &.small {
      font-size: 12px;
      color: $font_color_second;
    }

    &.passive {
    }
  }
  .checkbox__value {
    display: none;
  }
}
</style>
